<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 157.61 157.61"
    class="c-icon"
  >
    <line
      x1="152.61"
      y1="5"
      x2="5"
      y2="152.61"
      class="c-icon__line"
    />
    <line
      x1="5"
      y1="5"
      x2="152.61"
      y2="152.61"
      class="c-icon__line"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconClose',
};
</script>